import React from 'react'

import styled from '@emotion/styled'
import Cookies from 'js-cookie'
import { Trans, useTranslation } from 'react-i18next'

import { PaddingInset, Text } from '@cash-design-system/react'

import { SESSION_ASSOCIATION_COOKIE_NAME } from './constants'

const ChameleonLink = styled.a`
  color: inherit;
`

function grantSkipCookiePresent() {
  return !!Cookies.get(SESSION_ASSOCIATION_COOKIE_NAME)
}

const Link = ({ children, link, ariaLabel }: React.PropsWithChildren<{ link: string; ariaLabel: string }>) => (
  <Text typography="linkSmall" color="textProminent">
    <ChameleonLink href={link} target="_blank" rel="noreferrer" aria-label={ariaLabel}>
      {children}
    </ChameleonLink>
  </Text>
)

export function DataSharingLegalText() {
  const { t } = useTranslation()

  if (!grantSkipCookiePresent()) {
    return null
  }

  return (
    <PaddingInset>
      <Text typography="bodySmall" color="textSubtle">
        <Trans
          i18nKey={`By continuing, you agree to <PrivacyPolicy>Afterpay's privacy policy</PrivacyPolicy> and data sharing between Cash App and Afterpay.`}
          context="Footer text. Links to terms of service, e-sign consent, and privacy policy."
          components={{
            PrivacyPolicy: (
              <Link
                link="https://www.afterpay.com/en-US/privacy-policy"
                key="https://www.afterpay.com/en-US/privacy-policy"
                ariaLabel={t('URL link to privacy policy.', { context: 'Privacy policy link' })}
              />
            ),
          }}
        />
      </Text>
    </PaddingInset>
  )
}
